import { roundToDecimal } from "@tt-app/utils";

export function getHoursAndMinutes(minutes: number) {
  const hours = Math.floor(minutes / 60);
  const leftOverMinutes = minutes % 60;
  const roundedMinutes = roundToDecimal(leftOverMinutes, 2);
  return { hours: hours, minutes: roundedMinutes };
}
